module.exports = __webpack_public_path__ + "img/arrabbiato.61d82232.png";